export const SHARED = 'shared'
export const CANCELLED = 'cancelled'
export const EXPIRED = 'expired'
export const PENDING = 'pending'
export const DOWNLOADED = 'downloaded'
